import API from "./commons/Api.js";
import Utils from './commons/utils.js';
import {eventBus, EVENTS} from './commons/EventBus.js';
import router from "./commons/Router.js";


eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
    const template = data.template;

    if (template != "richiedi_scherzo") {
        return;
    }


    if (user.checkUser() == false) {
        console.log("non sei loggato");
    } else {
        user.checkUser(function (user) {

            $("#nome_input").val(user.nome || "");
            $("#cognome_input").val(user.cognome || "");
            $("#email_input").val(user.email || "");
            $("#telefono_input").val(user.telefono || "");

        });
    }


    API.post("site/get_tipologia_scherzi", {}, function (resp) {

        var listato_scherzi = "";
        $.each(resp.items, function (index, value) {

            listato_scherzi += "<div class='scherzo_option' data-value=\'" + value.key + "\'>" +
                "" + value.value +
                "</div>";
        });

        $("#option_scherzi_cont").append(listato_scherzi);
        $('.open_drop_scherzo').on('click',function () {
    
            $("#option_scherzi_cont").slideToggle();
            $(this).find(".icon_select_scherzo").toggleClass("open");
    
        });
    
        $('.scherzo_option').on('click',function () {
    
                $(".scherzo_option").removeClass("scherzo_selected");
                $(this).addClass("scherzo_selected");
                $(".open_drop_scherzo").trigger("click");
                $("#scherzo_scelto").val($(this).attr("data-value"));
                $("#nome_scherzo").text($(this).text());
    
            }
        );
        $(".open_drop_scherzo").trigger("click");
        $(".scherzo_option:first-child").trigger("click");
    });



    $('.step_scherzo_button').on('click',function () {
            var num_page = getComputedStyle(document.documentElement).getPropertyValue('--paginatore_scherzo');
            if (num_page == "0") {
                checkLoggedFirstBlock(num_page);
            } else if (num_page == "1") {
                checkSecondBlock(num_page);
            } else if (num_page == "2") {
                checkThirdBlock();
            }
            $("html, body").animate({scrollTop: 0}, 500);
    
    
        });
    
    
    function checkLoggedFirstBlock(num_page) {
    
        if (user.checkUser()) {
            checkFirstBlock(num_page);
        } else {
            user.popUpRichiediScherzo();
        }
    }
    
    
    function checkFirstBlock(num_page) {
    
        let in_error = false;
        let nome = $("input#nome_input").val();
        let cognome = $("input#cognome_input").val();
        let email = $("input#email_input").val();
        let telefono = $("input#telefono_input").val();
        let citta_origine_input = $("input#citta_origine_input").val();
    
        if (nome == "") {
            $(".fieldset-dati-nome").addClass("fieldset-error");
            $("#error-message-nome").html("Nome obbligatorio");
            in_error = true;
        }
    
        if (cognome == "") {
            $(".fieldset-dati-cognome").addClass("fieldset-error");
            $("#error-message-cognome").html("Cognome obbligatorio");
            in_error = true;
        }
    
        if (email == "") {
            $(".fieldset-dati-email").addClass("fieldset-error");
            $("#error-message-email").html("Email obbligatorio");
            in_error = true;
        }
        if (telefono == "") {
            $(".fieldset-dati-telefono").addClass("fieldset-error");
            $("#error-message-telefono").html("Telefono obbligatorio");
            in_error = true;
        }
        if (citta_origine_input == "") {
            $(".fieldset-dati-citta-origine").addClass("fieldset-error");
            $("#error-message-citta_origine").html("Città di origine obbligatoria");
            in_error = true;
        }
    
        if (!in_error) {
            $(".counter_step").removeClass("selected");
            num_page = parseInt(num_page) + 1;
            $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
            $(':root').css('--paginatore_scherzo', num_page.toString());
            $(".error-messages").html("");
            $("fieldset").removeClass("fieldset-error");
        }
    }
    
    function checkSecondBlock(num_page) {
    
        let in_error = false;
        let nome = $("input#target_nome_input").val();
        let cognome = $("input#target_cognome_input").val();
        let citta_origine_input = $("input#target_citta_origine_input").val();
        let citta_input = $("input#target_citta_input").val();
        let data_nascita = $("input#target_nascita_input").val();
        let telefono = $("input#target_telefono_input").val();
    
        if (nome == "") {
            $(".fieldset-dati-nome-target").addClass("fieldset-error");
            $("#error-message-nome-target").html("Nome obbligatorio");
            in_error = true;
        }
    
        if (cognome == "") {
            $(".fieldset-dati-cognome-target").addClass("fieldset-error");
            $("#error-message-cognome-target").html("Cognome obbligatorio");
            in_error = true;
        }
        if (citta_origine_input == "") {
            $(".fieldset-dati-citta-origine-target").addClass("fieldset-error");
            $("#error-message-citta_origine-target").html("Città di origine obbligatoria");
            in_error = true;
        }
        if (citta_input == "") {
            $(".fieldset-dati-citta-target").addClass("fieldset-error");
            $("#error-message-citta-target").html("Città di residenza obbligatoria");
            in_error = true;
        }
    
        if (data_nascita == "") {
            $(".fieldset-dati-nascita").addClass("fieldset-error");
            $("#error-message-nascita-target").html("Data di nascita obbligatoria");
            in_error = true;
        }
    
        if (telefono == "") {
            $(".fieldset-dati-telefono-target").addClass("fieldset-error");
            $("#error-message-telefono-target").html("Telefono obbligatorio");
            in_error = true;
        }
    
        if (!in_error) {
    
            $(".counter_step").removeClass("selected");
            num_page = parseInt(num_page) + 1;
            $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
            $(':root').css('--paginatore_scherzo', num_page.toString());
            $("#error_informativa").hide();
            $(".error-messages").html("");
            $("fieldset").removeClass("fieldset-error");
        }
    
    }
    
    function checkThirdBlock() {
    
        let in_error = false;
        let scherzo = $("input#scherzo_scelto").val();
        let parentela = $("input#parentela_input").val();
        let note = $("input#note_input").val();
        let informativa = $("input#condizioni_scherzo");
    
        if (parentela == "") {
            $(".fieldset-dati-parentela").addClass("fieldset-error");
            $("#error-message-parentela").html("Parentela obbligatorio");
            in_error = true;
        }
    
        if (note == "") {
            $(".fieldset-dati-note").addClass("fieldset-error");
            $("#error-message-note").html("Note obbligatorio");
            in_error = true;
        }
    
        if (!informativa.is(":checked")) {
            in_error = true;
            $("#error_informativa").show();
        }
    
        if (!in_error) {
            inviaScherzo();
        }
    
    }
    
    $('previous_step').on('click',function () {
            $(".counter_step").removeClass("selected");
            var num_page = getComputedStyle(document.documentElement).getPropertyValue('--paginatore_scherzo');
            num_page = parseInt(num_page) - 1;
            $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
            $(':root').css('--paginatore_scherzo', num_page.toString());
    
        });
    
    function inviaScherzo() {
    
        user.checkUser(function (user) {
    
            $("#form_scherzo").append("<input type='hidden' id='user_id_input' name='user_id_input' value=\'" + user.userid + "\'>");
            Utils.showWaitingLoader();
            //inserimento su nuovo backend
            API.post("site/inserisci_scherzo", $("#form_scherzo").serialize(), function (resp) {
                // hideWaitingLoader();
    
                if (resp.status == 0) {
    
                    $("#container_step_richiesta").empty();
                    $(".nascondi_title").remove();
                    $(".counter_step").removeClass("selected");
                    var num_page = 0;
                    $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
                    $(':root').css('--paginatore_scherzo', num_page.toString());
    
                    $("#container_step_richiesta").append(
                        "<div class='messaggio_inviato_scherzo'>" +
                        "<div class='font_54 font_34_mobile font_48_tablet sofia_font bold'>Grazie per aver partecipato!</div>" +
                        "<p class='sofia_font font_18_mobile line_heigth_mobile'>Riceverai una mail di conferma di avvenuta ricezione. Se il tuo scherzo verrà selezionato sarai ricontattato dalla nostra redazione. Continua a seguire Tutti Pazzi!</p>" +
                        "</div>"
                    );
                    Utils.hideWaitingLoader();
                } else {
                    alertError("Si è verificato un errore, prova di nuovo fra qualche istante");
                    console.log("errore sull'invio dello scherzo");
                }
    
            }, function () {
    
            });
    
        });
    
    //});
    }
    
});








